import Splide from "@splidejs/splide";

document.addEventListener("DOMContentLoaded", function () {
  const timelineCarousels = document.querySelectorAll(".timeline-carousel");

  if (timelineCarousels) {
    timelineCarousels.forEach(function (carousel) {
      const splide = new Splide(carousel, {
        type: "loop",
        perPage: 1,
        perMove: 1,
        gap: "16px",
        arrows: false,
        pagination: true,
      });

      splide.mount();

      // Bind custom arrows scoped to this block
      const block = carousel.closest(".timeline-block");
      if (!block) return;

      const prevBtn = block.querySelector(".timeline-arrow--prev");
      const nextBtn = block.querySelector(".timeline-arrow--next");

      if (prevBtn) {
        prevBtn.addEventListener("click", function () {
          splide.go("<");
        });
      }
      if (nextBtn) {
        nextBtn.addEventListener("click", function () {
          splide.go(">");
        });
      }
    });
  }
});
